import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/custom.scss";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "./store";

if (process.env.NODE_ENV === "production") {
    Sentry.init({
        dsn: "https://1e91d535c5b880528d0107d987de4409@o4507571489210368.ingest.de.sentry.io/4509054927634512",
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Sentry.ErrorBoundary
                fallback={
                    <div className="d-flex flex-column align-items-center justify-content-center text-danger py-10">
                        <div className="fw-bold text-center fs-1">
                            Something went wrong. Please try again later. 🚨
                        </div>
                    </div>
                }
            >
                <ToastContainer />
                <App />
            </Sentry.ErrorBoundary>
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);
